var React = require('react');

function Medium (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 29.867h-10.125c-3.759 0-9.075 5.423-9.075 8.894v125.826c0 3.475 5.316 8.213 9.075 8.213H256v29.867h-91.733V172.8h19.2V40.533h-.941L137.69 202.667h-34.712L58.72 40.533H57.6V172.8h19.2v29.867H0V172.8h9.835c4.049 0 9.365-4.738 9.365-8.213V38.76c0-3.471-5.316-8.894-9.365-8.894H0V0h96.034l31.53 117.333h.87L160.253 0H256v29.867"}));
}

Medium.defaultProps = {"width":"2500","height":"1982","viewBox":"0 0 256 203","fill":"white"};

module.exports = Medium;

Medium.default = Medium;
